import type { fabric } from 'fabric';
import type { FabricEditor } from '../core/fabric-editor';
import type { EditorPlugin } from '../interfaces/editor-plugin';
import { FabricPluginName } from './plugin-name';

export interface SelectionFacade {
  getActive(): fabric.Object[];
  clear(): void;
  set(target: fabric.Object): void;
}

declare module '../core/fabric-editor' {
  interface FabricEditor {
    selection?: SelectionFacade;
  }
}

export function selectionPlugin(): EditorPlugin {
  return {
    name: FabricPluginName.SELECTION,
    install(editor: FabricEditor) {
      editor.selection = {
        getActive: () => editor.canvas.getActiveObjects(),
        clear: () => {
          editor.canvas.discardActiveObject();
          editor.canvas.requestRenderAll();
        },
        set: (target) => {
          editor.canvas.setActiveObject(target);
          editor.canvas.requestRenderAll();
        },
      };
    },
    dispose(editor: FabricEditor) {
      editor.selection = undefined;
    },
  };
}
